<template>
  <div>
    <base-nav
      container-classes="container-fluid"
      class="navbar-top border-bottom navbar-expand"
      :class="{ 'bg-primary fixed-nav navbar-dark': type === 'default' }"
    >
      <base-button type="icon-only openSideMob" @click="closeSide" class="mr-0">
        <i class="flaticon-left-arrow-line-symbol"></i>
      </base-button>

      <img
        src="@/assets/img/rhombuss-dispath-neg.png"
        alt="rhombuss"
        class="logonav ml-2"
      />

      <ul class="navbar-nav align-items-center ml-md-auto"></ul>
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item pl-3 pr-3 name-branch">
          <i class="flaticon-organization"></i>
          <span> {{ brancName(branch) }}</span>
        </li>
        <li class="nav-item">
          <el-tooltip content="Dispatch Panel" placement="bottom">
            <router-link to="/dispatch-panel" class="nav-link">
              <i class="flaticon-dispatch"></i>
            </router-link>
          </el-tooltip>
        </li>
        <li class="nav-item">
          <el-tooltip content="Drivers Map" placement="bottom">
            <router-link to="/drivers-map" class="nav-link">
              <i class="flaticon-map"></i>
            </router-link>
          </el-tooltip>
        </li>

        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        >
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle">
                <img
                  v-if="profile.image !== ''"
                  alt="Image placeholder"
                  :src="profile.image"
                />
                <img
                  v-else
                  alt="Image placeholder"
                  src="img/user-placeholder.png"
                />
              </span>
              <div class="media-body ml-2 d-none d-lg-block">
                <span class="link-drop"
                  >{{ profile.first_name }} {{ profile.last_name }}</span
                >
              </div>
            </div>
          </a>

          <template>
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>

            <div>
              <a
                href="javascript:;"
                v-for="(element, index) in sesion.account_type.managers"
                :key="index"
                class="dropdown-item"
                :class="{ 'item-active': element._id == branch }"
                @click="selectBranch(element)"
              >
                <i class="flaticon-organization"></i>
                <span class="hide-data2">{{ element.name }}</span>
              </a>

              <div class="dropdown-divider"></div>
            </div>

            <router-link to="/profile" class="dropdown-item">
              <i class="flaticon-profile"></i>
              <span>My profile</span>
            </router-link>

            <div class="dropdown-divider"></div>
            <a href="javascript:;" class="dropdown-item" @click="logout()">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </template>
        </base-dropdown>
      </ul>
    </base-nav>
    <!-- init preloader -->
    <div class="sk-folding-cube" v-if="loader">
      <div class="sk-cube1 sk-cube"></div>
      <div class="sk-cube2 sk-cube"></div>
      <div class="sk-cube4 sk-cube"></div>
      <div class="sk-cube3 sk-cube"></div>
    </div>
    <div id="overlay" v-if="loader"></div>
    <!-- end preloader -->
  </div>
</template>
<script>
import { BaseNav } from "@/components";
import { mapGetters, mapActions, mapMutations } from "vuex";
import "../../../scss/themes/default.scss";

export default {
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      filters: [],
    };
  },
  components: {
    BaseNav,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  async created() {
    this.getBranch();
    this.getSesion();
    await this.getProfile();
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    openCloseSidebar() {
      this.setsidebarOpen("sidebar-open");
    },
    closeSide() {
      if (this.activeView == "dispatchPanel") {
        this.setsidebarOpen("");
      } else if (this.activeView == "driversMap") {
        this.setsidebarOpenMap("");
      }
    },
    logout() {
      localStorage.removeItem("dp-sesion");
      localStorage.removeItem("dp-duplicate");
      this.$router.push("/login");
    },
    selectBranch(branch) {
      this.filters = this.query.split("&").filter((element) => element !== "");
      let index = this.filters.indexOf(`branch=${this.branch}`);
      if (index > -1) {
        this.setBranch(branch._id);
        let remove = this.filters.splice(index, 1);
        this.filters.push(`branch=${branch._id}`);
        this.setQuery(this.filters.join("&"));
      } else {
        this.setBranch(branch._id);
        this.filters.push(`branch=${branch._id}`);
        this.setQuery(this.filters.join("&"));
      }
      this.getReservations({});
      this.getDrivers(branch._id);
      this.getDriversOptions(branch._id);
      this.setDriverId("");
    },
    brancName(branchId) {
      let managers = this.sesion.account_type.managers;
      let branch = managers.find((item) => item._id === branchId);
      if (branch) {
        return branch.name;
      } else {
        return "";
      }
    },
    ...mapActions([
      "getProfile",
      "getSesion",
      "getBranch",
      "getReservations",
      "getDrivers",
      "getDriversOptions",
    ]),
    ...mapMutations([
      "setActiveView",
      "setsidebarOpen",
      "setsidebarOpenMap",
      "setthemeColor",
      "setLoader",
      "setBranch",
      "setQuery",
      "setDriverId",
    ]),
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters([
      "sidebarOpen",
      "sidebarOpenMap",
      "activeView",
      "themeColor",
      "loader",
      "profile",
      "branch",
      "sesion",
      "query",
    ]),
  },
};
</script>
